import { createSelector } from '@ngrx/store';

import { menuFlowsState } from '../root';

export const getMenuFlow = (menuFlowId: number, locationNo: number) =>
    createSelector(
        menuFlowsState,
        (menuFlows) => menuFlows.find((menuFlow) => menuFlow.MenuFlowId === menuFlowId && menuFlow.LocationNo === locationNo) || null
    );
